export default class UserBasicSettings {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.form = document.getElementById("userBasicDataForm");

    if (!this.form) return;

    this.action = this.form.getAttribute("action");
    this.elements = this.form.elements;
    this.avatarOld = document.getElementById('avatarOld');
    this.avatarField = document.getElementById("avatarFile");
    this.avatarSizeLimit = 2000000; //2MB
    this.avatarFileTypes = ["image/jpg", "image/png", "image/jpeg"];

    this.removeAvatar = document.getElementById("fileRemove");
    this.avatarImage = document.getElementById("avatarImage");

    this.rules = {
      phone: {
        rule: new RegExp("^[0-9]{9}$"),
        message: "Numer może zawierać tylko cyfry."
      },
      avatar: {
        rule: "image",
        message: "Awatar jest niepoprawny"
      }
    };

    this.errors = [];

    return true;
  }

  setupEvents() {
    this.form.addEventListener("submit", evt => this.handleSubmit(evt));
    this.avatarField.addEventListener("change", evt =>
      this.updateAvatarPreview(evt)
    );

    if (this.removeAvatar) {
      this.removeAvatar.addEventListener("click", () => {
        this.avatarField.value = "";
        this.removeAvatar.style.display = "none";
        this.avatarOld.value = "";

        if (this.avatarImage) {
          const original = this.avatarImage.getAttribute("data-placeholder");
          this.avatarImage.setAttribute("src", original);
        }
      });
    }
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.clearValidationErrors();

    const data = this.buildData();

    if (!this.errors.length) {
      this.send(data);
    } else {
      this.throwValidationError();
    }
  }

  buildData() {
    let data = new FormData();

    for (let i = 0; i < this.elements.length; i++) {
      const el = this.elements[i];

      if (el.getAttribute("type") !== "submit") {
        const key = el.getAttribute("name");
        if (key === "avatar") {
          const val = el.files[0];
          this.validate(key, val);
          if (val instanceof File) {
            data.append(key, val);
          }
        } else {
          const val = el.value !== "placeholder" ? el.value : "";
          this.validate(key, val);
          data.append(key, val);
        }
      }
    }

    return data;
  }

  send(data) {
    const settings = {
      headers: {
        "content-type": "multipart/form-data;"
      }
    };

    axios
      .post(this.action, data, settings)
      .then(response => {
        if (response && response.data.code === 200) {
          document._kweber.toast({
            type: "success",
            title: "Ustawienia zapisane!"
          });
        } else {
          throw new Error(response);
        }
      })
      .catch(error => {
        document._kweber.toast({
          type: "error",
          title: "Błąd zapisu, spróbuj ponownie"
        });
      });
  }

  validate(key, val) {
    if (val === undefined) return;

    if ((this.rules[key] !== undefined && val.length) || val instanceof File) {
      if (this.rules[key].rule instanceof RegExp) {
        if (!val.match(this.rules[key].rule)) {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      } else if (this.rules[key].rule === "image") {
        if (
          val.size > this.avatarSizeLimit ||
          this.avatarFileTypes.indexOf(val.type) < 0
        ) {
          const error = {
            name: key,
            msg: this.rules[key].message
          };
          this.errors.push(error);
        }
      }
    }
  }

  throwValidationError() {
    this.errors.forEach(error => {
      const field = this.elements.namedItem(error.name);
      const node = field.closest("div");
      field.classList.add("form-invalid-right");
      node.appendChild(this.getErrorNode(error.name, error.msg));
    });
  }

  clearValidationErrors() {
    this.errors = [];
    const errorNodes = this.form.getElementsByClassName("form-error");
    const errorFields = this.form.getElementsByClassName("form-invalid-right");
    Array.from(errorNodes).forEach(node => {
      node.remove();
    });

    Array.from(errorFields).forEach(field => {
      field.classList.remove("form-invalid-right");
    });
  }

  getErrorNode(key, msg) {
    const label = document.createElement("label");
    label.setAttribute("for", key);
    label.classList.add("form-error");
    label.classList.add("form-invalid-right");
    label.innerText = msg;
    return label;
  }

  updateAvatarPreview(evt) {
    const container = this.avatarField.closest(".avatar-row");
    const [image] = container.querySelectorAll("img");

    const file = this.avatarField.files[0];
    if (
      file.size > this.avatarSizeLimit ||
      this.avatarFileTypes.indexOf(file.type) < 0
    ) {
      const error = {
        name: "avatar",
        msg: this.rules["avatar"].message
      };
      this.errors.push(error);
      this.throwValidationError();
    } else {
      image.setAttribute("src", window.URL.createObjectURL(file));
      this.removeAvatar.style.display = "block";
      this.avatarOld.value = "1";
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/UserBasicSettings.js